<template>
  <div class="card chat_container">
    <div class="chat_left_sidebar" :class="{ mobile: $device?.mobile }">
      <div class="chat_wrapper">
        <label class="title">
          <span>Direct Messages</span>
          <span><i class="fa fa-plus"></i></span>
        </label>
        <div class="chat_user_list">
          <div v-for="_user in 15" :key="_user" class="chat_user_item" :class="{ active: _user == 5 && !$device?.mobile }">
            <img :src="user?.logo" />
            <div class="chat_user_name">Message {{ _user }}</div>
          </div>
        </div>
      </div>
      <div class="chat_wrapper">
        <label class="title">
          <span>Channels</span>
          <span><i class="fa fa-plus"></i></span>
        </label>
        <div class="chat_user_list">
          <div v-for="_user in 10" :key="_user" class="chat_user_item">
            <img :src="user?.logo" />
            <div class="chat_user_name">Channel {{ _user }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="user_chat" v-if="!$device?.mobile">
      <div class="chat_content">
        <div class="user_chat_container">
          <div class="chat_header_section">
            <div class="chat_header_wrapper">
              <div class="chat_user_title">
                <div class="user_image_name">
                  <img :src="user.logo" alt="" />
                  <div class="chat_user_name">
                    <span class="title">{{ user.name }}</span>
                    <span class="chat_information">Last seen 1 year ago</span>
                  </div>
                </div>
              </div>
              <div class="chat_user_extra">
                <a class="chat_info_icon"><i class="fa fa-info"></i></a>
              </div>
            </div>
          </div>
          <div class="chat_conversation">
            <div class="chat_list_item" v-for="(item, index) in 5" :class="[index % 2 == 0 ? 'left' : 'right']" :key="index">
              <div class="chat_list_content">
                Hey, I'm going to meet a friend of mine at the department store. I have to buy some presents for my parents 🎁.Hey, I'm going to meet a friend of mine at the department store. I have
                to buy some presents for my parents 🎁.Hey, I'm going to meet a friend of mine at the department store. I have to buy some presents for my parents 🎁.Hey, I'm going to meet a friend of
                mine at the department store. I have to buy some presents for my parents 🎁.Hey, I'm going to meet a friend of mine at the department store. I have to buy some presents for my parents
                🎁.Hey, I'm going to meet a friend of mine at the department store. I have to buy some presents for my parents 🎁
              </div>
            </div>
          </div>
          <div class="chat_input_section">
            <div class="chat_input_wrapper">
              <div class="chat_input_content">
                <div class="links-list-item">
                  <a><i class="fa-regular fa-face-smile"></i> </a>
                </div>
                <div class="chat_input_field">
                  <input type="text" placeholder="Message" />
                </div>
                <div class="links-list-item">
                  <a><i class="fa-regular fa-send"></i> </a>
                </div>
              </div>
            </div>
            <!--  <div class="row g-2 align-items-center">
              <div class="col-auto">
                <div class="d-flex me-2">
                  <div class="links-list-item">
                    <a><i class="fa-regular fa-face-smile"></i> </a>
                  </div>
                </div>
              </div>
            </div> -->
            <!-- <div class="row g-2">
                <div class="col-auto">
                  <div class="chat-input-links me-2">
                    <div class="links-list-item">
                      <a class="clr-teal">
                        <i class="fa-regular fa-face-smile fnt-14 align-middle"></i>
                      </a>
                    </div>
                  </div>
                </div>
  
                <div class="col">
                  <div class="chat-input-feedback">Please Enter a Message</div>
                  <input type="text" class="form-control form-control-sm" placeholder="Type your message..." autocomplete="off" />
                </div>
                <div class="col-auto">
                  <div class="chat-input-links ms-2">
                    <div class="links-list-item">
                      <button type="submit" class="btn btn-success chat-send waves-effect waves-light">
                        <i class="ri-send-plane-2-fill align-bottom"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  title: "Chat",
  name: "Messages"
};
</script>

<style lang="scss">
$content-margin: 10px;

.chat_container {
  display: flex;
  flex-direction: row !important;
  height: calc(100% - #{$content-margin}) !important;
  width: 100%;
  flex-direction: column;
  margin-top: $content-margin;
  color: var(--body-text-color);
  .chat_left_sidebar {
    display: flex;
    width: 15%;
    overflow: hidden;
    overflow-y: auto;
    &.mobile {
      width: 100%;
    }
    flex-direction: column;
    z-index: 1;
    /* box-shadow: 6px 0px 10px -5px rgba(255, 255, 255, 0.5); */
    .chat_wrapper {
      .title {
        text-transform: uppercase;
        background-color: var(--dp-chat-heading-background);
        font-size: var(--fnt-10);
        padding: 6px 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        .fa-plus {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 18px;
          height: 18px;
          background-color: var(--teal-dark);
          font-size: var(--fnt-9);
          cursor: pointer;
        }
      }
      .chat_user_list {
        .chat_user_item {
          display: flex;
          user-select: none;
          cursor: pointer;
          padding: 5px 15px;
          font-weight: 500;
          align-items: center;
          margin-bottom: 0;
          font-size: 0.8125rem;
          font-weight: 600;
          &:hover,
          &.active {
            background-color: rgba(39, 125, 117, 0.5);
            color: var(--body-text-color);
          }
          img {
            width: 22px;
            border-radius: 50%;
            margin-right: 8px;
          }
          .chat_user_name {
            font-size: var(--fnt-10);
          }
        }
      }
    }
  }
  .user_chat {
    background-image: url("/public/img/chat-bg.png");
    background-color: var(--dp-chat-conversation-background);
    transition: all 0.4s;
    position: relative;
    /*  background-repeat: repeat;
    background-size: cover; */
    border-left: 1px solid var(--dp-c-border-color);
    overflow: hidden;
    width: 85%;
    .chat_content {
      position: relative;
      height: 100%;
      .user_chat_container {
        position: relative;
        height: 100%;
        flex-wrap: wrap;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        .chat_header_section {
          height: 45px;
          width: 100%;
          border-bottom: 1px solid var(--dp-c-border-color);
          background-color: var(--dp-c-card-background);
          .chat_header_wrapper {
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0px 15px;
            .chat_user_title {
              display: flex;
              .user_image_name {
                display: flex;
                align-items: center;
                img {
                  border-radius: 50%;
                  margin-right: 8px;
                  width: 25px;
                  height: 25px;
                }
                .chat_user_name {
                  display: flex;
                  flex-direction: column;
                  font-size: var(--fnt-12);
                  &:hover {
                    background-color: var(--bs-gray-800);
                  }
                  .title {
                    font-weight: 600;
                  }
                  .chat_information {
                    font-size: var(--fnt-10);
                    margin-top: 0.2rem;
                  }
                }
              }
            }
            .chat_user_extra {
              .chat_info_icon {
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                color: var(--body-text-color);
                border-radius: 50%;
                font-size: var(--fnt-9);
                font-weight: 600;
                width: 20px;
                height: 20px;
                border: 1px solid var(--body-text-color);
              }
            }
          }
        }
        .chat_conversation {
          padding: 10px 24px;
          height: calc(100% - 90px);
          width: 100%;
          overflow: hidden;
          overflow-y: auto;
          .chat_list_item {
            display: flex;
            &:not(:last-child) {
              margin-bottom: 0.8rem;
            }
            .chat_list_content {
              max-width: 80%;
              padding: 12px 15px;
              background-color: #282b2e;
              position: relative;
              border-radius: 3px;
              box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
            }
            &.left {
              justify-content: flex-start;
            }
            &.right {
              justify-content: flex-end;
              .chat_list_content {
                background-color: var(--teal-dark);
                color: #fff;
              }
            }
          }
        }
        .chat_input_section {
          border-top: 1px solid var(--dp-c-border-color);
          background-color: var(--dp-c-card-background);
          position: relative;
          height: 45px;
          width: 100%;
          display: flex;
          align-items: center;
          padding: 0px 15px;
          z-index: 1;
          .chat_input_wrapper {
            width: 100%;
            .chat_input_content {
              border-radius: 15px;
              width: 100%;
              display: flex;
              padding: 5px 10px;
              align-items: center;
              background-color: var(--dp-chat-heading-background);
              color: var(--dp-chat-input-section);
              .links-list-item {
                a {
                  font-size: var(--fnt-16);
                  cursor: pointer;
                  position: relative;
                  top: 0.5px;
                  width: 37.5px;
                  height: 37.5px;
                }
              }
              .chat_input_field {
                width: 100%;
                input {
                  border: 0;
                  width: 100%;
                  margin-left: 8px;
                  font-size: var(--fnt-13);
                  height: 100%;
                  color: var(--dp-chat-input-section);
                  background-color: transparent;
                  &::placeholder {
                    color: var(--dp-chat-input-section);
                  }
                  &:visited,
                  &:focus-visible,
                  &:focus {
                    outline: 0;
                    border: 0;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>